import { IButtonContent } from 'src/app/models_new/types/info-card-config';

export function getElementByNameTag(
  buttonElements: IButtonContent[],
  nameTag: string
): IButtonContent {
  return buttonElements?.find((e) => e.nameTag === nameTag) || undefined;
}
